export default "__VITE_ASSET__DxTrK$SZ__"